import { gql } from "@apollo/client";
export default gql`
  query getDeliveryOuts($start: Date, $end: Date) {
    getDeliveryOuts(start: $start, end: $end) {
      ok
      error
      count
      data {
        _id
        docNo

        time
        opType
        title
        desc

        costAmount
        total
        discount
        amount

        refNo
        refType

        invoiceitems
        attachments

        supplierId
        supplierName
        supplierNameAr

        customerId
        customerName
        customerNameAr

        stockId
        stockName
        stockNameAr

        userId

        createdAt
        updatedAt
      }
    }
  }
`;
